import { render } from "./Integrations.vue?vue&type=template&id=bf411dbc"
import script from "./Integrations.vue?vue&type=script&lang=js"
export * from "./Integrations.vue?vue&type=script&lang=js"

import "./Integrations.vue?vue&type=style&index=0&id=bf411dbc&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__